(() => {
  if (customElements.get("korman-advent-calendar")) return;
  class KormanAdventCalendar extends HTMLElement {
    connectedCallback() {
      if (this.timer !== undefined) return;
      this.events = new AbortController();
      const eventOptions = { signal: this.events.signal };
      dayjs.extend(window.dayjs_plugin_utc);
      dayjs.extend(window.dayjs_plugin_timezone);

      let endAt;
      try {
        endAt = dayjs.tz(this.dataset.end, this.dataset.timeZone);
      } catch {
        endAt = null;
      }
      const wrappers = this.querySelectorAll(".korman-advent-box-wrapper");
      const subtext = this.querySelector(".korman-advent-advent-subtext");
      this.liveDescription ??= subtext?.innerHTML;

      const update = () => {
        const ended = !endAt?.isValid() || dayjs().valueOf() >= endAt.valueOf();
        if (subtext) {
          if (ended) subtext.textContent = this.dataset.expiredMessage;
          else subtext.innerHTML = this.liveDescription;
        }
        wrappers.forEach((wrapper) => {
          wrapper.classList.remove("locked", "available", "expired", "opened");
          wrapper.classList.add(ended ? "expired" : "available");
          for (const selector of [
            ".korman-advent-present__label",
            ".korman-advent-present__countdown",
          ]) {
            const element = wrapper.querySelector(selector);
            if (element) element.textContent = "";
          }
        });
        if (ended) {
          this.querySelectorAll(".korman-advent-product-modal.active").forEach((modal) => {
            modal.classList.remove("active");
          });
        }
      };

      wrappers.forEach((wrapper) => {
        wrapper.querySelector(".korman-advent-present__content")?.addEventListener(
          "click",
          (event) => {
            update();
            if (!wrapper.classList.contains("available")) return;
            event.preventDefault();
            event.stopPropagation();
            wrapper.querySelector(".korman-advent-product-modal")?.classList.add("active");
          },
          eventOptions,
        );
      });
      this.querySelectorAll(".korman-advent-close-btn").forEach((button) => {
        button.addEventListener(
          "click",
          (event) => {
            event.stopPropagation();
            button.closest(".korman-advent-product-modal")?.classList.remove("active");
          },
          eventOptions,
        );
      });
      this.querySelectorAll(".korman-advent-product-modal").forEach((modal) => {
        modal.addEventListener(
          "click",
          (event) => {
            if (event.target === modal) {
              event.stopPropagation();
              modal.classList.remove("active");
            }
          },
          eventOptions,
        );
      });
      this.addEventListener(
        "keydown",
        (event) => {
          if (event.key === "Escape") {
            this.querySelectorAll(".korman-advent-product-modal.active").forEach((modal) => {
              modal.classList.remove("active");
            });
          }
        },
        eventOptions,
      );
      update();
      this.timer = window.setInterval(update, 1000);
    }

    disconnectedCallback() {
      window.clearInterval(this.timer);
      this.timer = undefined;
      this.events?.abort();
    }
  }

  if (!customElements.get("korman-advent-calendar")) {
    customElements.define("korman-advent-calendar", KormanAdventCalendar);
  }
})();
